//#region import libraries
import { useEffect, useMemo, useState } from "react";
import { useHistory } from 'react-router-dom';
//react modal
import Modal from "react-modal"
// custom components
import { Card, CustomSpinner, DateTime } from "_atoms";
import { BookingTable, TableHeader, TableValue } from "_molecules";

// bootstrap
import { Button, Col, Container, Row } from "react-bootstrap";

// libraries
import { add } from "date-fns";

// redux
import { useDispatch, useSelector } from "react-redux";
import { selectIata, selectUserDb } from "_redux/slices/main-screen/user";
import * as arrivalsSlice from "_redux/slices/prm-bookings/arrivals";
import { selectAirlineSelectedAirport } from "_redux/slices/prm-bookings/bookings";
import * as countSlice from "_redux/slices/prm-bookings/bookings-count";
import {
  exportForecast,
  selectArrivalsForecastList,
  selectDepartureForecastList,
  selectDeparturesArrivalsCountByHourForecast,
  selectDeparturesArrivalsWeeklyCountByHourForecast,
  selectFlightCountAnalytics,
  selectWeeklyArrivalsForecastList,
  selectWeeklyDepartureForecastList,
  getDeparturesFlightForecastByDateRange,
  getArrivalsFlightForecastByDateRange,
  selectDeparturesFlightsForecasStatus,
  selectArrivalsFlightsForecastStatus,
  selectArrivalsFlightForecastData,
  selectDepartureFlightForecastData,
  resetForecastFlights
} from "_redux/slices/prm-bookings/bookings-count";
import { selectBookingForecastTableType, setForecastTable } from "_redux/slices/prm-bookings/bookings-table";
import { selectDateToISO, selectOrder, setDate } from "_redux/slices/prm-bookings/calendar";
import * as departuresSlice from "_redux/slices/prm-bookings/departures";
import ForecastAnalytics from "_scenes/portal/analytics/booking-analytics/forecastAnalytics";
import { setSelectedFlight } from '_redux/slices/flights/flight-information';

// utils
import { Colors } from "_styles";
//icons
import { IoMdClose } from "react-icons/io";

// tremor
import { DateRangePicker, Flex, Subtitle, Toggle, ToggleItem, Title as TremorTitle } from "@tremor/react";
//#endregion

const modalStyle = {
  content: {
    top: "30%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "50%",
    width: "30%",
    minHeight: "50%"
  },
};

const BookingsList = () => {
  // nav
  const history = useHistory();

  //#region functions of reports
  const handleDailyActivitiesReport = async () => {
    /* fixed 24 hours for header */
    const hoursList = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23,
    ];

    // categories in left column
    const categories = [
      "Departures",
      "Arrivals",
      "Totals",
      "DepFlights",
      "ArrFlights",
      "TotalFlights",
      "AgentsOnDuty",
    ];

    let departureFlights = [];
    let departureFlightDictionary = {};

    let arrivalFlights = [];
    let arrivalFlightDictionary = {};

    let totalFlights = [];

    arrivalsForecast.forEach((forecastedFlight) => {
      let flight = forecastedFlight.flight;
      let time = forecastedFlight.formattedTime;
      let hour = new Date(time).getHours();
      if (!arrivalFlightDictionary[hour]) {
        arrivalFlightDictionary[hour] = 1;
      } else {
        arrivalFlightDictionary[hour] += 1;
      }
    });

    departuresForecast.forEach((forecastedFlight) => {
      let flight = forecastedFlight.flight;
      let time = forecastedFlight.formattedTime;
      let hour = new Date(time).getHours();
      if (!departureFlightDictionary[hour]) {
        departureFlightDictionary[hour] = 1;
      } else {
        departureFlightDictionary[hour] += 1;
      }
    });

    hoursList.forEach((hour) => {
      // add departure count
      if (departureFlightDictionary[hour]) {
        departureFlights.push(departureFlightDictionary[hour]);
      } else {
        departureFlights.push("");
      }

      // add arrival count
      if (arrivalFlightDictionary[hour]) {
        arrivalFlights.push(arrivalFlightDictionary[hour]);
      } else {
        arrivalFlights.push("");
      }

      // add total count
      if (departureFlightDictionary[hour] && arrivalFlightDictionary[hour]) {
        totalFlights.push(
          departureFlightDictionary[hour] + arrivalFlightDictionary[hour]
        );
      } else if (departureFlightDictionary[hour]) {
        totalFlights.push(departureFlightDictionary[hour]);
      } else if (arrivalFlightDictionary[hour]) {
        totalFlights.push(arrivalFlightDictionary[hour]);
      } else {
        totalFlights.push("");
      }
    });

    let hours = [];
    let departures = [];
    let arrivals = [];
    let totals = [];

    hourData.forEach((forecast) => {
      let hour = forecast.name;
      let arrivalCount = forecast["Arrivals"];
      let departureCount = forecast["Departures"];

      hours.push(hour);
      departures.push(departureCount > 0 ? departureCount : "");
      arrivals.push(arrivalCount > 0 ? arrivalCount : "");
      totals.push(
        departureCount + arrivalCount > 0 ? departureCount + arrivalCount : ""
      );
    });

    // prepare data
    const data = {
      Departures: departures,
      Arrivals: arrivals,
      Totals: totals,
      DepFlights: departureFlights,
      ArrFlights: arrivalFlights,
      TotalFlights: totalFlights,
      AgentsOnDuty: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    };

    // converts data to CSV
    function convertToCSV(data) {
      const headers = ["Hours", ...hours, "Total"];
      let rows = categories.map((category) =>
        [
          category,
          ...data[category],
          data[category].reduce((a, b) => (b ? a + b : a), 0),
        ].join(",")
      );

      // Find the indices of "Totals" and "TotalFlights"
      const totalsIndex = categories.indexOf("Totals");
      const totalFlightsIndex = categories.indexOf("TotalFlights");

      // Create an empty row with the correct number of columns
      const emptyRow = Array(headers.length).fill("").join(",");

      // Insert an empty row after the "Totals" row
      if (totalsIndex >= 0) {
        rows.splice(totalsIndex + 1, 0, emptyRow);
      }

      // Adjust the index for "TotalFlights" if necessary
      const adjustedTotalFlightsIndex =
        totalFlightsIndex > totalsIndex
          ? totalFlightsIndex + 1
          : totalFlightsIndex;

      // Insert an empty row after the "TotalFlights" row
      if (adjustedTotalFlightsIndex >= 0) {
        rows.splice(adjustedTotalFlightsIndex + 1, 0, emptyRow);
      }

      return [headers.join(","), ...rows].join("\n");
    }

    // downloads CSV file
    function downloadCSV(csvString, filename = "data.csv") {
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    const csvString = convertToCSV(data);
    downloadCSV(csvString, "daily_activities_.csv");
  };

  const handleWeeklyActivitiesReport = async () => {
    const categories = [
      "Day",
      "Departures",
      "Arrivals",
      "Totals",
      "DepFlights",
      "ArrFlights",
      "TotalFlights",
      "AgentsOnDuty",
    ];

    const dataByDay = {};

    // Process each day for hour data
    Object.keys(weeklyHourData).forEach((day) => {
      const dayData = weeklyHourData[day];
      const arrivals = dayData.map((entry) => entry.Arrivals);
      const departures = dayData.map((entry) => entry.Departures);
      const totals = dayData.map((entry) => entry.Departures + entry.Arrivals);

      // Calculate flight counts by the hour
      const depFlights = new Array(24).fill(0);
      const arrFlights = new Array(24).fill(0);
      weeklyDeparturesForecast[day]?.forEach((flight) => {
        let hour = new Date(flight?.formattedTime).getHours();
        depFlights[hour]++;
      });
      weeklyArrivalsForecast[day]?.forEach((flight) => {
        let hour = new Date(flight?.formattedTime).getHours();
        arrFlights[hour]++;
      });

      const totalFlights = depFlights.map(
        (dep, index) => dep + arrFlights[index]
      );

      dataByDay[day] = {
        Day: day,
        Departures: departures,
        Arrivals: arrivals,
        Totals: totals,
        DepFlights: depFlights,
        ArrFlights: arrFlights,
        TotalFlights: totalFlights,
        AgentsOnDuty: new Array(24).fill(""),
      };
    });

    // Convert organized data to CSV by day
    function convertToCSV(data) {
      const headers = [
        "Hour",
        ...new Array(24).fill("").map((_, index) => `${index}:00`),
        "Total",
      ];
      const rows = Object.keys(data).map((day) => {
        return categories
          .map((category) => {
            // Ensure the data field for the current category is an array
            let categoryData = Array.isArray(data[day][category])
              ? data[day][category]
              : [];
            // remove zeros from categoryData and replace it with empty string
            let formattedCategoryData = categoryData.map((item) =>
              item === 0 ? "" : item
            );
            return [
              category === "Day" ? day : category,
              ...formattedCategoryData,
              // Safely use reduce only if categoryData is an array
              category === "Day"
                ? ""
                : formattedCategoryData.reduce((a, b) => (b ? a + b : a), 0),
            ].join(",");
          })
          .join("\n");
      });

      return [headers.join(","), ...rows].join("\n\n");
    }

    // Generate and download CSV
    const csvString = convertToCSV(dataByDay);
    downloadCSV(csvString, "weekly_activities_report.csv");
  };

  // Function to download CSV
  function downloadCSV(csvString, filename = "data.csv") {
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  //#endregion

  //#region state + redux
  // redux variables
  const dispatch = useDispatch();

  // state variables used for daily activities report
  const hourData = useSelector(selectDeparturesArrivalsCountByHourForecast);
  const weeklyHourData = useSelector(
    selectDeparturesArrivalsWeeklyCountByHourForecast
  );

  const dbUser = useSelector(selectUserDb);
  const date = useSelector(selectDateToISO); // selected date from calendar
  const analyticsTypeSelector = useSelector(
    countSlice.selectAnalyticsTypeSelector
  ); // 'source' (app/sita/portal) or 'none' (all bookings)

  // arrivals TODO figure out why the arrivals section is not working
  const arrivalsForecast = useSelector(selectArrivalsForecastList);
  const weeklyArrivalsForecast = useSelector(selectWeeklyArrivalsForecastList);
  const arrivalSkip = useSelector(arrivalsSlice.selectArrivalsSkip);
  // departures
  const departuresForecast = useSelector(selectDepartureForecastList);
  const weeklyDeparturesForecast = useSelector(selectWeeklyDepartureForecastList);
  const departureSkip = useSelector(departuresSlice.selectDepartureSkip);
  const forecastFlightCountAnalytics = useSelector(selectFlightCountAnalytics); //  total count of flights, total departures + total arrival flights
  const departuresFlightsForecastStatus = useSelector(selectDeparturesFlightsForecasStatus)
  const arrivalsFlightsForecastStatus = useSelector(selectArrivalsFlightsForecastStatus)
  const departuresFlightsForecast = useSelector(selectDepartureFlightForecastData)
  const arrivalsFlightsForecast = useSelector(selectArrivalsFlightForecastData)
  // table
  const type = useSelector(selectBookingForecastTableType);
  const airport = useSelector(selectAirlineSelectedAirport);
  const order = useSelector(selectOrder);
  const controller = new AbortController();
  const iata = useSelector(selectIata);
  //#endregion

  //#region local state
  const [filter, setFilter] = useState(dbUser.details.type == "AIRLINE" ? iata : "");
  const [openExportModal, setOpenExportModal] = useState(false)
  const [exportDate, setExportDate] = useState([new Date(), new Date()]);                                   // holds value of the date range for exporting forecast
  //#endregion

  // export forecasting table to csv
  const handleExport = () => {
    // prepare data

    const iata = dbUser.details.authority;
    let payload = {
      iata: dbUser.details.type != "AIRLINE" ? iata : airport,
      start: exportDate[0],
      end: exportDate[1] ? exportDate[1] : exportDate[0],
      limit: 1000000,
      skip: 0,
      search: "",
      order: order,
      carrierCode: dbUser.details.type == "AIRLINE" ? iata : "",
      source: analyticsTypeSelector,
      forecast: true,
    }
    if (type == "Departures") {
      dispatch(getDeparturesFlightForecastByDateRange(payload, controller.signal));
    } else {
      dispatch(getArrivalsFlightForecastByDateRange(payload, controller.signal));
    }

  };


  //#region useEffect

  //reset all flags for forecasting flights
  useEffect(() => {
    dispatch(resetForecastFlights())
  }, [])

  //export data when forecast d
  useEffect(() => {

    if (arrivalsFlightsForecastStatus === "succeeded" || departuresFlightsForecastStatus === "succeeded") {
      const data = type === "Departures" ? departuresFlightsForecast : arrivalsFlightsForecast;
      dispatch(
        exportForecast({
          data: data,
          type: type == "Departures" ? "departures" : "arrivals",
          date: exportDate,
        })
      );
      dispatch(resetForecastFlights())
    }
  }, [arrivalsFlightsForecastStatus, departuresFlightsForecastStatus])

  useEffect(() => {
    let countParams = {
      iata: dbUser.details.type == "AIRLINE" ? airport : iata,
      date: date,
      endDate: add(new Date(date), { days: 0 }).toISOString().split("T")[0],
      source: analyticsTypeSelector,
      airline:
        dbUser.details.type == "AIRLINE" ? dbUser.details.authority : null,
      byFlight: true,
    };
    dispatch(countSlice.getAnalyticsCountInboundByHourForForecast(countParams));
    dispatch(
      countSlice.getWeeklyAnalyticsCountInboundByHourForForecast({
        ...countParams,
        endDate: add(new Date(date), { days: 7 }).toISOString().split("T")[0],
      })
    );

    dispatch(countSlice.getAnalyticsCountOutboundByHourForForecast(countParams));

    dispatch(
      countSlice.getWeeklyAnalyticsCountOutboundByHourForForecast({
        ...countParams,
        endDate: add(new Date(date), { days: 7 }).toISOString().split("T")[0],
      })
    );
    dispatch(
      countSlice.getAnalyticsCountInboundByHour({
        iata: dbUser.details.type == "AIRLINE" ? airport : iata,
        date: date,
        endDate: add(new Date(date), { days: 0 }).toISOString().split("T")[0],
        source: analyticsTypeSelector,
        airline:
          dbUser.details.type == "AIRLINE" ? dbUser.details.authority : null,
      })
    );
    dispatch(
      countSlice.getAnalyticsCountOutboundByHour({
        iata: dbUser.details.type == "AIRLINE" ? airport : iata,
        date: date,
        endDate: add(new Date(date), { days: 0 }).toISOString().split("T")[0],
        source: analyticsTypeSelector,
        airline:
          dbUser.details.type == "AIRLINE" ? dbUser.details.authority : null,
      })
    );
  }, [analyticsTypeSelector, date, airport]);

  // get list and count
  useEffect(() => {
    // reset departures and arrivals list
    dispatch(departuresSlice.reset());
    dispatch(arrivalsSlice.reset());


    // if user exsists
    if (dbUser) {
      // get forecast
      dispatch(
        countSlice.getDeparturesCountForecast(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 1000,
            skip: 0,
            search: "",
            carrierCode: filter,
            order: order,
            type: "outbound",
            source: analyticsTypeSelector,
            forecast: true,
          },
          controller.signal
        )
      );
      dispatch(
        countSlice.getArrivalsCountForecast(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 1000,
            skip: 0,
            search: "",
            carrierCode: filter,
            order: order,
            type: "inbound",
            source: analyticsTypeSelector,
            forecast: true,
          },
          controller.signal
        )
      );
      // get bookings
      dispatch(
        countSlice.getDeparturesForecast(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 1000,
            skip: departureSkip,
            search: "",
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
            forecast: true,
          },
          controller.signal
        )
      );

      // get weekly departures forecast
      dispatch(
        countSlice.getWeeklyDeparturesForecast(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: add(new Date(date), { days: 7 }).toISOString().split("T")[0],
            limit: 3000,
            skip: departureSkip,
            search: "",
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
            forecast: true,
          },
          controller.signal
        )
      );

      // get arrivals
      dispatch(
        countSlice.getArrivalsForecast(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 1000,
            skip: arrivalSkip,
            search: "",
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
            forecast: true,
          },
          controller.signal
        )
      );

      // get weekly arrivals forecast
      dispatch(
        countSlice.getWeeklyArrivalsForecast(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: add(new Date(date), { days: 7 }).toISOString().split("T")[0],
            limit: 3000,
            skip: arrivalSkip,
            search: "",
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
            forecast: true,
          },
          controller.signal
        )
      );
    }
  }, [airport, date, analyticsTypeSelector]);

  //#endregion
  // columns for table
  let forecastColumns = useMemo(
    () => [
      {
        Header: (
          <TableHeader
            title={type == "Departures" ? "Departure Time" : "Arrival Time"} />
        ),
        accessor: "time",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue title={value} comment={false} />
          </div>
        ),
      },
      {
        Header: <TableHeader title={"Flight"} />,
        accessor: "flight",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue title={value} comment={false} />
          </div>
        ),
      },
      {
        Header: <TableHeader title={"Forecasted"} />,
        accessor: "average",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue title={value} comment={false} />
          </div>
        ),
      },
      {
        Header: <TableHeader title={type == 'Departures' ? "No Show Forecast" : ""} />,
        accessor: "noShowAverage",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue title={type == 'Departures' ? value : ''} comment={false} />
          </div>
        ),
      },
      {
        Header: <TableHeader title={"Actual"} />,
        accessor: "actual",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue title={value | 0} comment={false} />
          </div>
        ),
      },
      {
        Header: <TableHeader title={"Forecast Variance"} />,
        accessor: "variance",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue
              title={value}
              comment={false}
              textColor={
                value > 2.9 || value < -2.9
                  ? "red"
                  : value > 1.9 || value < -1.9
                    ? "orange"
                    : Colors.TEXT_COLOR
              }
            />
          </div>
        ),
      },
    ],
    [type]
  );

  //#region functions

  //function to set selected/clicked flight
  const handleFlightClick = (i) => {
    // use index to find flight that was clicked
    let flight = {};
    if (type == "Departures") {
      flight = departuresForecast[i];
    }
    else {
      flight = arrivalsForecast[i];
    }

    let selectedFlight = {
      flight: flight.flight,
      date: flight.formattedTime,
      document: flight.id,
      type: type,
    }

    dispatch(setSelectedFlight(selectedFlight));

    // navigate to flight page
    history.push('/flight-information');

  }

  //open modal function
  const handleOpenModal = () => {
    setOpenExportModal(true);
  }
  //close modal function+reset flights forecast flags
  const closeExportModal = () => {
    setOpenExportModal(false);
    setExportDate([new Date(), new Date()]);
    dispatch(resetForecastFlights())
  }

  //#endregion

  return (
    <>
      {
        <Container className="mt-2" style={{ paddingBottom: 50 }}>
          {/* date selector */}
          <Row className="justify-content-md-center">
            <Col xs={9} />

            <Col md="auto" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <DateTime date={date} setDate={(date) => { dispatch(setDate(date)); }} />
            </Col>
          </Row>

          <ForecastAnalytics />

          {/* Forecast Table */}
          <Card shadow={true} decoration="top" className="mt-3" decorationColor={type == "Departures" ? "blue" : "green"}>
            {/* title + departure / arrival tab */}
            <Row>
              <Flex>
                {/* title */}
                <Col style={{ marginLeft: 12 }}>
                  <TremorTitle>Booking Forecast</TremorTitle>
                  <Subtitle>View the the forecasted passengers on each flight and the actual bookings made on the flight</Subtitle>
                </Col>

                {/* departure / arrival tab */}
                <Toggle color="zinc" defaultValue={type} onValueChange={(value) => dispatch(setForecastTable(value))}>
                  <ToggleItem value={"Departures"} text="Departures" />
                  <ToggleItem value={"Arrivals"} text="Arrivals" />
                </Toggle>
              </Flex>
            </Row>
            <>

              <body className="mt-3" style={{ overflowY: "scroll", height: "40em", display: "block", padding: "10px" }}>
                <BookingTable
                  columns={forecastColumns}
                  data={type == "Departures" ? departuresForecast : arrivalsForecast}
                  showMore={true}
                  handleClick={(i) => { handleFlightClick(i) }}
                />
              </body>


              <Flex>
                {/* export buttons */}
                <div style={{ display: "flex" }}>
                  <Button variant={"outline-secondary"} onClick={handleOpenModal} loading={true} style={{ width: 180, marginLeft: 15, marginTop: 12 }}                  >Export Forecast</Button>
                  <Button variant={"outline-secondary"} onClick={handleDailyActivitiesReport} loading={true} style={{ marginLeft: 15, width: 200, marginTop: 12 }}>Export Daily Activities</Button>
                  <Button variant={"outline-secondary"} onClick={handleWeeklyActivitiesReport} loading={true} style={{ marginLeft: 15, width: 200, marginTop: 12 }}>Export Weekly Activities</Button>
                </div>

                {/* total flight info */}
                <div className="mt-3" style={{ display: "flex", marginRight: 12 }}>
                  <TableValue title={"Total Flights: " + forecastFlightCountAnalytics.totalCount} marginLeft={0} />

                  <TableValue title={"Departures: " + forecastFlightCountAnalytics.departureCount} marginLeft={16} />

                  <TableValue title={"Arrivals: " + forecastFlightCountAnalytics.arrivalCount} marginLeft={12} />
                </div>
              </Flex>
            </>
            {/* Modal date range select to export forecast      */}

            <Modal isOpen={openExportModal} onRequestClose={closeExportModal} style={modalStyle}>
              <div>
                {/*modal header + close icon*/}
                <Flex>
                  <h4>Export Forecast by date range</h4>
                  <IoMdClose onClick={closeExportModal} style={{ cursor: "pointer" }} color={"grey"} size={32} />
                </Flex>

                <hr color={Colors.PRM_LIGHT_BLUE} />
                {/*modal body datepicker + export button*/}
                <DateRangePicker
                  onValueChange={(value) => setExportDate(value)}
                  value={exportDate}
                  enableDropdown={true}
                  maxWidth="max-w-lg"
                  dropdownPlaceholder={"Today"}
                  minDate={new Date().setMonth(new Date().getMonth() - 12)} // set the minimum selectable date to 12 months ago
                />
                <Button variant={"outline-secondary"} onClick={handleExport} loading={true} style={{ width: 180, marginLeft: 15, marginTop: 12 }}>
                  {departuresFlightsForecastStatus == "loading" || arrivalsFlightsForecastStatus == "loading" ? <CustomSpinner /> : "Export"}
                </Button>
              </div>
            </Modal>
          </Card>
        </Container>
      }
    </>
  );
};

export default BookingsList;
